import { ButtonWithIcon } from 'common-components'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'
import { ChessGridBackground } from 'styles/consts'

export const UploadedImageContainer = styled.div<{ $isDragActive: boolean }>`
  position: relative;
  width: 100%;
  max-height: 235px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px dashed
    ${props => (props.$isDragActive ? COLORS.primaryDark : 'transparent')};
  transition: border-color 0.2s ease;
  aspect-ratio: 1/1;
`

export const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;

  ${ChessGridBackground}
`

export const ImageOverlay = styled.div<{ $show: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #252e4899;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  opacity: ${props => (props.$show ? 1 : 0)};
  transition: opacity 0.2s ease;
  cursor: pointer;
  padding: 0 54px;
`

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #252e4899;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 8px;
  z-index: 10;
`
export const Button = styled(ButtonWithIcon)`
  justify-content: center;
  height: 32px;
  background-color: ${COLORS.secondaryExtraDark};
  border-color: ${COLORS.secondaryExtraDark};

  & > span {
    color: ${COLORS.white};
  }

  & > svg {
    path {
      fill: ${COLORS.white};
    }
  }

  &:hover {
    background-color: ${COLORS.secondaryExtraDark};
    border-color: ${COLORS.white};

    & > span {
      color: ${COLORS.white};
    }

    & > svg {
      path {
        fill: ${COLORS.white};
      }
    }
  }
`

export const CloseButtonWrapper = styled.div<{ $show: boolean }>`
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: ${props => (props.$show ? 1 : 0)};
  transition: opacity 0.2s ease;
  cursor: pointer;
  z-index: 10;

  & > svg {
    fill: ${COLORS.white};
  }

  &:hover {
    opacity: 1;
  }
`
